module.exports = __webpack_public_path__ + "ui-static/img/logo-header_light.16192311.svg";